import React, { memo } from 'react'
import { useTranslation } from 'react-i18next'
import Clear from '@material-ui/icons/Clear';
import { IconButton, Textfield } from '@workboard/wobo-ui';
import { UserItemRenderer } from '@workboard/ui-search';
import styled from 'styled-components';
import { CheckBoxComp } from '../../../inputs/fields.component'
import { showTitleTooltip } from '../../../../utils/function'

const StyledIconButton = styled(IconButton)`
    width: 24px;
    height: 24px;
    svg {
      width: 24px;
      height: 24px;
    }
`;

const IntervalTexts = {
  1: 'daily',
  2: 'weekly',
  3: 'monthly',
  4: 'quarterly',
  5: 'once',
  6: 'bi-weekly',
}

const MetricValueText = (progress_type) => {
  let text = 'Last value'
  if (progress_type == '1') {
    text = 'Last value'
  } else if (progress_type == '2') {
    text = 'Sum'
  } else if (progress_type == '3') {
    text = 'Average'
  } else if (progress_type == '4') {
    text = 'Sum of last value'
  }
  return text
}

export const RollUpTableComp = (props) => {
  let {
    row,
    searchKR = false,
    type = '',
    tableClass = '',
    rowClick,
    checkBoxProps,
    checkedValues = [],
    removeItem = false,
    showProgress = true,
    inst,
    addClass='',
  } = props
  let name = '',
    subtext = '',
    pic = '',
    rowAttr = {},
    showPicCol = false,
    peopleType = ''
  if (type == 'kr') {
    let year = `${row['okrPeriod']}` //"FY" + moment(row["create_at"],"MMM DD, YYYY").format("YY");
    // if(row["end_date"]){
    //   year = "FY" + moment(row["end_date"],"MM/DD/YYYY").format("YY");
    // }
    if (year.includes('Q')) {
      let yearArray = year.split(' ');
      year =
        yearArray[0] +
        ' FY ' + yearArray[1].slice(-2)
       
    } else if (year.includes('FY')) {
      year = ' FY ' + year.slice(-2)
    }
    name = row.name
    let intervalText =
      typeof IntervalTexts[row.interval] && row.interval != '0'
        ? IntervalTexts[row.interval]
        : ''
    let targetText = row.targetDisplay
      ? row.achieveTargetText + ' of ' + row.totalTargetText
      : row.achieveTargetText
    let subtitle1 = `${row.kr_owner} @@DOTCLASS@@`
    let subtitle2 = targetText
    subtext = subtitle1 ? subtitle1 + ' ' + subtitle2 : subtitle2
    subtext = subtext + ' @@DOTCLASS@@ ' + year

    if (row.teamName) {
      subtext = row.teamName + ' @@DOTCLASS@@ ' + subtext
    }
  } else if (type == 'okr') {
    name = row.goal
    let valToProgress = row.progress >= 0 ? row.progress + '%' : '--'
    let achieveDate = row.achieveDate
    if (
      typeof row.achieveDateWithYear !== 'undefined' &&
      row.achieveDateWithYear !== null
    ) {
      achieveDate = row.achieveDateWithYear
    }

    //let year = 'FY' + moment(achieveDate, 'MMM DD, YYYY').format('YY')
    let year = row['okrPeriod'] //"FY" + moment(row["create_at"],"MMM DD, YYYY").format("YY");
    if (year.includes('Q')) {
      let yearArray = year.split(' ');
      year = yearArray[0] +' FY ' + yearArray[1].slice(-2)
    } else if (year.includes('FY')) {
      year = ' FY ' + year.slice(-2)
    }
    subtext = row.ownerFullName + ' @@DOTCLASS@@ ' + year
    subtext = row.teamName ? row.teamName + ' @@DOTCLASS@@ ' + subtext : subtext
  } else if (type == 'people') {
    showPicCol = true
    peopleType = row.type || ''
    if (peopleType == '2') {
      name = row.teamName
      pic = ''
    } else if (peopleType == '1') {
      name =
        typeof row.fullName !== 'undefined'
          ? row.fullName
          : row.firstName + ' ' + row.lastName
      pic =
        typeof row.userPic !== 'undefined'
          ? row.userPic
          : typeof row.picture !== 'undefined'
          ? row.picture
          : ''
    } else {
      showPicCol = false
      name = row.name
    }
  } else if (type == 'publish') {
    showPicCol = false
    peopleType = row.type || ''
    name = row.label
    if (peopleType == '2') {
      showPicCol = true
      pic = ''
    } else if (peopleType == '3') {
      showPicCol = true
      pic =
        typeof row.userPic !== 'undefined'
          ? row.userPic
          : typeof row.picture !== 'undefined'
          ? row.picture
          : ''
    }
  } else if (type == 'publishOkrSel') {
    name = row.item.label
    let achieveDate = row.item.achieveDate
    if (
      typeof row.item.achieveDateWithYear !== 'undefined' &&
      row.item.achieveDateWithYear !== null
    ) {
      achieveDate = row.item.achieveDateWithYear
    }
    subtext = row.item.ownerFullName + ' @@DOTCLASS@@ ' + achieveDate
    subtext = row.item.teamName
      ? row.item.teamName + ' @@DOTCLASS@@ ' + subtext
      : subtext
  }
  const isPersonRow = type == 'people' && peopleType == '1'

  if (rowClick) {
    rowAttr.onClick = (e) => rowClick(e, row, inst)
  }
  let isChecked = false
  let checkboxId = ''
  let rowId = peopleType + '-' + row.userId + '-' + row.teamId

  if (checkBoxProps) {
    let rowType = typeof row.type !== 'undefined' ? row.type : 1
    checkboxId =
      'chk-box-' +
      type +
      '-' +
      rowType +
      '-' +
      (type == 'people' ? row.userId + '-' + row.teamId : row.id)
    if (type == 'people') {
      let typeOfRow = rowType + '_' + (rowType == '2' ? row.teamId : row.userId)
      isChecked = checkedValues.find((v) => v == typeOfRow) ? true : false
    } else if (type == 'publish') {
      isChecked = checkedValues.find(
        (v) => v.itemId == row.typeName + '-' + row.id
      )
        ? true
        : false
    } else {
      isChecked = checkedValues.find((v) => v == row.id) ? true : false
    }
    checkBoxProps.checkboxProps = {
      checked: isChecked,
    }
  }
  return (
    <div className={'rollup-table ' + tableClass}>
      <div className="rollup-row">
        {checkBoxProps ? (
          <div
            className="rollup-col rollup-checkbox"
            data-testid="rollup-row-checkbox"
          >
            <CheckBoxComp
              key={checkboxId}
              id={checkboxId}
              subclassDefined="displayInLineBlk"
              item={row}
              {...checkBoxProps}
            />
          </div>
        ) : (
          ''
        )}
        {isPersonRow ? (
          <div
            className={`rollup-col rollup-col-title ${
              checkBoxProps ? ' en-rollup-checkbox' : ''
            }`}
          >
            <div
              id={`rollup-remove-icon-${row.user_id}`}
              className="showtooltip-title"
              data-testid="rollup-title"
              data-rowid={rowId}
              {...rowAttr}
            >
              <UserItemRenderer
                option={{ fullName: name, email: row.email, picture: pic }}
              />
            </div>
          </div>
        ) : (
          <>
            {showPicCol ? (
              <div className="rollup-col rollup-pic-col">
                {peopleType == '2' ? (
                  <div className="icon icon-outline-people-24px " />
                ) : (
                  <UserRoundPictureComp key={pic || row.userId} pic={pic} />
                )}
              </div>
            ) : (
              ''
            )}
            <div
              className={
                'rollup-col rollup-col-title ' +
                (checkBoxProps ? ' en-rollup-checkbox' : '')
              }
            >
              <div className="rollup-title"  data-testid="rollup-title">
                <div
                  id={`rollup-remove-icon-${row.user_id}`}
                  className="showtooltip-title showtooltip-only-title"
                  data-rowid={rowId}
                  {...rowAttr}
                  {...showTitleTooltip(name)}
                >
                  {name}
                </div>
              </div>
              {subtext ? (
                <div className="rollup-item-info">
                  <div
                    className="rollup-item-info1 showtooltip-title"
                    data-testid="rollup-item-info"
                    style={{ cursor: "default" }}
                    {...showTitleTooltip(subtext.replace(/@@DOTCLASS@@/gi, "."))}
                    dangerouslySetInnerHTML={{
                      __html: subtext.replace(
                        /@@DOTCLASS@@/gi,
                        '<span class="dotClass">.</span>'
                      ),
                    }}
                  />
                </div>
              ) : (
                ''
              )}
            </div>
          </>
        )}
        {removeItem ? (
          <div className="rollup-col rollup-col-remove">
            <IconButton
              onClick={(e) => removeItem(e, row)}
              className={`icon icon-outline-close-24px MuiSvgIcon-root deleteOptionBtn ${addClass}`}
              aria-label='Remove'
              data-testid="icon-close"
              aria-describedby={`rollup-remove-icon-${row.id}`}
              id={`deleteOptionBtn${row.id}`}
            >
              <Clear />
            </IconButton>
          </div>
        ) : (
          ''
        )}
      </div>
    </div>
  )
}

export const RollUpKrSearchTableComp = (props) => {
  let { value, attr = {}, inst } = props
  let metrics = value.metrics || []
  let subText =
    value.cascade_goal_id && value.cascade_goal_id != ''
      ? 'Owner: ' + value.fullName
      : value.teamName
      ? `Team: ${value.teamName}`
      : ''
  const { t } = useTranslation()
  return (
    <div className="render-search-kr-item" data-testid="render-search-kr-item">
      <div className="rollup-table rollup-table-goal">
        <div className="rollup-row">
          {!value.cascade_goal_id && (
            <div className="rollup-col rollup-col-gprogress">
              <div
                className="goalprogress"
                style={{ color: value.progress_color }}
              >
                {value.progress < 0 ? '--' : value.progress + '%'}
              </div>
            </div>
          )}
          <div className="rollup-col rollup-col-gname">
            <div
              className="goaltitle showtooltip-title"
              {...showTitleTooltip(value.goal)}
            >
              {value.cascade_goal_id && value.cascade_goal_id != ''
                ? t('Cascaded Key Result')
                : value.goal}
            </div>
            {subText ? (
              <div
                className="subtitle showtooltip-title"
                {...showTitleTooltip(subText)}
              >
                {subText}
              </div>
            ) : (
              ''
            )}
          </div>
        </div>
      </div>
      {metrics.length
        ? metrics.map((m) => (
            <RollUpTableComp
              type="kr"
              searchKR={true}
              key={'search-' + m.id}
              tableClass="rollup-kr-search-table highlightRow"
              row={m}
              {...attr}
              inst={inst}
            />
          ))
        : ''}
    </div>
  )
}

export const PeopleSearchBoxList = memo(function (props) {
  let { row, attr = {}, inst } = props
  let { userId, teamId = 0 } = row
  let id = 'people-chk-' + userId + '-' + teamId
  const rowType = typeof row.type !== 'undefined' ? row.type : 1
  const typeOfRow = `${rowType}_${rowType == '2' ? teamId : userId}`
  const checkedValues = attr.checkedValues || []
  const isSelected = !!checkedValues.find((v) => v == typeOfRow)
  return (
    <div
      className="render-search-kr-item"
      data-testid="render-search-kr-item"
      role="option"
      aria-selected={isSelected}
    >
      <RollUpTableComp
        key={id}
        type="people"
        tableClass="rollup-people-search-table"
        row={row}
        {...attr}
        inst={inst}
      />
    </div>
  )
})

export const CascadeResultsTableComp = (props) => {
  let {
    row,
    tableClass = '',
    removeItem = false,
    isNew = false,
    removeUser = false,
  } = props
  let name =
    typeof row.fullName !== 'undefined'
      ? row.fullName
      : row.firstname + ' ' + row.lastname
  let rowAttr = {}
  let targetValue =
    typeof row.target !== 'undefined' && row.target != null ? row.target : ''
  let keyResultName = !isNew && row.name ? row.name : ''
  let statusText = ''
  let targetText = ''
  const { t, i18n } = useTranslation()
  if (!isNew) {
    if (row.status == 1) {
      statusText = t('Pending')
    } else {
      statusText = t('Active')
    }
    targetText = row.target
    if (row.counting == 4) {
      targetText = row.lower_limit + '-' + row.upper_limit
    }
  }
  let showRemoveItem =
    removeItem && ((!isNew && row.status == 1) || row.status == 3 || isNew)
  if (removeUser) {
    showRemoveItem = removeUser
  }
  return (
    <div className={'rollup-table ' + tableClass}>
      <div className="rollup-row">
        <div className="rollup-col rollup-col-title">
          <div className="rollup-title">
            <div
              className="showtooltip-title"
              {...rowAttr}
              {...showTitleTooltip(name)}
            >
              {name}
            </div>
          </div>
        </div>
        {!isNew ? (
          <div className="rollup-col rollup-col-status">
            <div>
              <span
                className={
                  'cascade-kr-status-text cascade-kr-status-' + row.status
                }
              >
                {statusText}
              </span>
              {row.status == 1 ? (
                <i
                  style={{ backgroundPositionX: '-734px' }}
                  className="icon icon-outline-notifications-18px cursor-pointer"
                  onClick={() => props.sendUserNotification(row)}
                ></i>
              ) : (
                ''
              )}
            </div>
          </div>
        ) : (
          ''
        )}
        {!isNew ? (
          <div className="rollup-col rollup-col-keyresult">
            <div
              className="showtooltip-title truncate"
              style={{ marginRight: '10px' }}
              {...showTitleTooltip(keyResultName)}
            >
              {keyResultName}
            </div>
          </div>
        ) : (
          ''
        )}
        <div className="rollup-col rollup-col-textbox">
          <div>
            {isNew ? (
              <Textfield
                type="text"
                className="text-target-field text-target-width"
                data-testid="personTargetValue"
                value={targetValue}
                onChange={(e) => props.changeTextBox(e, row)}
                autoComplete="off"
              />
            ) : (
              targetText
            )}
          </div>
        </div>

        <div className="rollup-col rollup-col-remove">
          <StyledIconButton
            className="icon icon-outline-close-24px"
            onClick={(e) => removeItem(e, row)}
            aria-label='Remove'
          >
            <Clear />
          </StyledIconButton>
        </div>
      </div>
    </div>
  )
}

export const CascadeResultsHeaderTableComp = (props) => {
  let { tableClass = '', isNew = false, realOwner = false } = props
  const { t } = useTranslation()
  return (
    <div className={'rollup-table rollup-header-table ' + tableClass}>
      <div className="rollup-row rollup-header-row">
        <div className="rollup-col rollup-col-title">
          <div>
            {isNew
              ? realOwner
                ? t('Selected cascade owner(s)') + ':'
                : t('Selected cascade assignee(s)') + ':'
              : t('Already assigned to') +':'}
          </div>
        </div>
        {!isNew ? (
          <div className="rollup-col rollup-col-status">
            <div>{t('Status')}</div>
          </div>
        ) : (
          ''
        )}
        {!isNew ? (
          <div className="rollup-col rollup-col-keyresult">
            <div>{t('Key Result')}</div>
          </div>
        ) : (
          ''
        )}
        <div className="rollup-col rollup-col-textbox">
          <div>{t('Target value')}</div>
        </div>
        <div className="rollup-col rollup-col-remove"></div>
      </div>
    </div>
  )
}

export const UserRoundPictureComp = (props) => {
  let { className = '' } = props
  return (
    <img
      src={props.pic}
      width="25"
      height="25"
      className={'border-radius-50 ' + className}
      alt=""
    />
  )
}

export const PublishSearchBoxList = (props) => {
  let { row, attr = {}, inst } = props
  let id = 'people-chk-' + row.type + '-' + row.id
  return (
    <div className="render-search-kr-item" data-testid="render-search-kr-item">
      <RollUpTableComp
        key={id}
        type="publish"
        tableClass="rollup-people-search-table"
        row={row}
        {...attr}
        inst={inst}
      />
    </div>
  )
}

export const TeamSelectedComp = (props) => {
  let { row, tableClass = '', removeItem = false, isNew = false } = props
  let name = row.item.label
  let rowAttr = {}
  let showRemoveItem = removeItem
  return (
    <div className={'rollup-table ' + tableClass}>
      <div className="rollup-row">
        <div className="rollup-col rollup-col-title">
          <div className="rollup-title">
            <div
              className="showtooltip-title"
              {...rowAttr}
              {...showTitleTooltip(name)}
            >
              {name}
            </div>
          </div>
        </div>

        <div className="rollup-col rollup-col-remove">
          {showRemoveItem ? (
            <div
              className="icon icon-outline-close-24px"
              onClick={(e) => removeItem(e, row)}
            ></div>
          ) : (
            ''
          )}
        </div>
      </div>
    </div>
  )
}

export default {
  RollUpTableComp,
  RollUpKrSearchTableComp,
  PeopleSearchBoxList,
  CascadeResultsTableComp,
  CascadeResultsHeaderTableComp,
  UserRoundPictureComp,
  PublishSearchBoxList,
  TeamSelectedComp,
}
